export function localDate(date = new Date()) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function formatMoney(value, currency = 'INR') {
    const amount = Number(value) || 0;
    const code = typeof currency === 'string' && /^[A-Z]{3}$/.test(currency) ? currency : 'INR';
    try {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: code,
            maximumFractionDigits: 2,
        }).format(amount);
    } catch (error) {
        return `${code} ${amount.toFixed(2)}`;
    }
}

export function formatNumber(value) {
    return new Intl.NumberFormat('en-IN').format(Number(value) || 0);
}

export function formatDayLabel(isoDate) {
    if (!isoDate) return '—';
    const date = new Date(`${isoDate}T12:00:00`);
    if (Number.isNaN(date.getTime())) return isoDate;
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}

export function formatMetric(value, formatter) {
    if (value == null) return '—';
    return formatter(value);
}

export function escapeCsv(value) {
    const text = String(value ?? '');
    return `"${text.replace(/"/g, '""')}"`;
}
